import React from 'react';
import { createAppContainer } from 'react-navigation';
import { createStackNavigator } from 'react-navigation-stack';
import MainScreen from './src/screens/MainScreen';
import LoginScreen from './src/screens/LoginScreen';
import { Provider as PaykeyDashboardProvider } from './src/context/PayKeyDashboardServerContext';
import AdminScreen from './src/screens/AdminScreen';
import { LOCAL_MODE } from './src/utils/ExternalKeys';

const navigator = createStackNavigator(
  {
    MainScreen,
    LoginScreen,
    AdminScreen,
  },
  {
    initialRouteName: LOCAL_MODE ? 'MainScreen' : 'LoginScreen',
    defaultNavigationOptions: {
      animationEnabled: false,
      title: 'PayKeyGO',
    },
  },
);

// wrapping navigator inside data provider:
const App = createAppContainer(navigator);
export default () => (
  <PaykeyDashboardProvider>
    <App />
  </PaykeyDashboardProvider>
);
